module.exports = "/_next/static/images/community_pool-c00217a41f846d3c004380cabb5b05ff.svg";